import script from "./ProductSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSection.vue?vue&type=script&setup=true&lang=js"

import "./ProductSection.vue?vue&type=style&index=0&id=6abf033e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6abf033e"]])

export default __exports__